<template>
  <a-empty description="Pagina este in constructie" />
</template>

<script>
export default {
  name: 'UnderConstruction'
}
</script>

<style scoped>

</style>
